import { InputAdornment, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useForm, Controller } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import editorConfiguration from "../../../util/EditorConfiguration";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import apiHelper from "../../../util/ApiHelper";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
  },
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: 0,
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const defaultFormValues = {
  subject: "",
  template: "",
  senderName: "",
  senderAddress: "",
  ccList: "",
};

function EntryEmailConfigurationPage({ disabled, ...props }) {
  const classes = useStyles();
  const [activeTab, setActiveTab] = React.useState(0);
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);

  const {
    control,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const getConfig = async () => {
    try {
      const result = await apiHelper.hkiff.getConfig();
      return result.data;
    } catch (err) {
      console.log(err);
    }
  };
  const getTemplate = async () => {
    try {
      const result = await apiHelper.hkiff.getTemplate();
      return result.data;
    } catch (err) {
      console.log(err);
    }
  };

  const saveConfig = (data) => {
    try {
      const result = apiHelper.hkiff.saveConfig(data);
      return result;
    } catch (err) {
      console.log(err);
    }
  };

  const saveTemplate = (data) => {
    try {
      const result = apiHelper.hkiff.saveTemplate(data);
      return result;
    } catch (err) {
      console.log(err);
    }
  };

  const getExistingConfig = React.useCallback(async () => {
    const config = await getConfig();
    const template = await getTemplate();
    setDefaultValues({ ...config, ...template });
  }, []);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const onSubmit = async (value) => {
    try {
      console.log(value);
      const configData = {
        address: value.address,
        ccList: value.ccList,
        name: value.name,
      };

      const templateData = {
        id: value.id,
        contentEN: value.contentEN,
        contentTC: value.contentTC,
        subjectEN: value.subjectEN,
        subjectTC: value.subjectTC,
      };

      const promiseArg = [];
      promiseArg.push(saveConfig(configData));
      promiseArg.push(saveTemplate(templateData));

      const result = await Promise.all(promiseArg);
      if (
        result.reduce(
          (accumulator = 0, currentValue) =>
            (accumulator = +currentValue.data.code)
        ) === 0
      ) {
        toast.dark("Setting saved.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  React.useEffect(() => {
    getExistingConfig();
  }, [getExistingConfig]);

  React.useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  console.log(defaultValues);

  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        Entry Management {'>'} Email Configuration
      </Typography>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{ style: { top: "0", background: "#306F9D" } }}
      >
        <Tab label="Template" {...a11yProps(0)} />
        <Tab label="General Settings" {...a11yProps(1)} />
      </Tabs>
      <form>
        <fieldset disabled={disabled} className="fieldset">
          <TabPanel value={activeTab} index={0}>
            <Box className={classes.innerBox} style={{ marginBottom: 0 }}>
              <Grid container direction="vertical" spacing={4}>
                <Grid item xs={12}>
                  <Controller
                    name={`subjectEN`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Subject title (EN)"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name={`subjectTC`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Subject title (TC)"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="contentEN"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="contentTC"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value}
                        disabled={disabled}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item style={{ padding: "0 20px 20px 20px" }}>
                  {disabled || (
                    <Button
                      type="button"
                      variant="contained"
                      disableElevation
                      style={{
                        color: "white",
                        background: "#306F9D",
                        marginRight: "5px",
                        padding: "9px 16px",
                      }}
                      onClick={handleSubmit(onSubmit)}
                    >
                      Save Changes
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
            <Box className={classes.innerBox} style={{ marginBottom: 0 }}>
              <Grid container direction="vertical" spacing={2}>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name={`name`}
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          label="Sender Name"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "The name is how it displayed in your contacts' inboxes."
                          }
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid item xs={6}>
                    <Controller
                      name={`address`}
                      control={control}
                      render={({ field, fieldState: { error } }) => (
                        <TextField
                          label="Sender Address"
                          variant="outlined"
                          margin="dense"
                          className={classes.textInput}
                          fullWidth
                          {...field}
                          defaultValue={field.value}
                          error={!!error}
                          helperText={
                            error
                              ? error.message
                              : "The sender address your contacts will see."
                          }
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                @HKIFF.org.hk
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Grid container item xs={12}>
                    <Grid item xs={6}>
                      <Typography>CC List</Typography>
                    </Grid>
                  </Grid>
                  <Grid container item xs={12}>
                    <Grid item xs={6}>
                      <Controller
                        name={`ccList`}
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <TextField
                            multiline
                            rows={5}
                            variant="outlined"
                            margin="dense"
                            className={classes.textInput}
                            //   fullWidth
                            {...field}
                            defaultValue={field.value}
                            error={!!error}
                            helperText={error ? error.message : ""}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} style={{ padding: "20px 20px 0px 0px" }}>
                  {disabled || (
                    <Button
                      type="button"
                      variant="contained"
                      disableElevation
                      style={{
                        color: "white",
                        background: "#306F9D",
                        marginRight: "5px",
                        padding: "9px 16px",
                      }}
                      onClick={handleSubmit(onSubmit)}
                    >
                      Save Changes
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
        </fieldset>
      </form>
    </div>
  );
}

export default EntryEmailConfigurationPage;
